import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Alert, Badge } from 'react-bootstrap';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // This would typically come from an API
    // For now, using mock data
    setLoading(true);
    setTimeout(() => {
      const mockEvents = [
        {
          id: 1,
          title: 'Annual Sports Day',
          date: '2024-12-15',
          description: 'Annual sports competition between departments',
          type: 'Sports',
          location: 'College Ground'
        },
        {
          id: 2,
          title: 'Tech Fest 2024',
          date: '2024-11-20',
          description: 'Annual technical festival with competitions and workshops',
          type: 'Technical',
          location: 'Main Auditorium'
        },
        {
          id: 3,
          title: 'Cultural Fest',
          date: '2024-10-10',
          description: 'Annual cultural festival with music and dance competitions',
          type: 'Cultural',
          location: 'Open Air Theatre'
        },
      ];
      setEvents(mockEvents);
      setLoading(false);
    }, 1000);
  }, []);

  const getEventTypeColor = (type) => {
    switch(type.toLowerCase()) {
      case 'sports': return 'success';
      case 'technical': return 'primary';
      case 'cultural': return 'warning';
      default: return 'secondary';
    }
  };

  return (
    <Container className="py-5">
      <h1 className="display-4 mb-4 text-center">Events & Activities</h1>
      <p className="lead text-center mb-5">
        Stay updated with our college events and activities
      </p>

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Loading events...</p>
        </div>
      ) : events.length > 0 ? (
        <Row>
          {events.map((event) => (
            <Col key={event.id} lg={4} md={6} className="mb-4">
              <Card className="h-100 shadow-sm card-hover">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <Card.Title className="text-primary mb-0">
                      {event.title}
                    </Card.Title>
                    <Badge bg={getEventTypeColor(event.type)}>
                      {event.type}
                    </Badge>
                  </div>
                  
                  <Card.Text className="text-dark mb-3">
                    {event.description}
                  </Card.Text>
                  
                  <div className="mt-auto">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <small className="text-muted">
                          <i className="fas fa-calendar me-1"></i>
                          {new Date(event.date).toLocaleDateString('en-US', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric'
                          })}
                        </small>
                      </div>
                      <div>
                        <small className="text-muted">
                          <i className="fas fa-map-marker-alt me-1"></i>
                          {event.location}
                        </small>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <div className="text-center py-5">
          <i className="fas fa-calendar-alt fa-3x text-muted mb-3"></i>
          <h3>No Events Scheduled</h3>
          <p className="text-muted">Check back later for upcoming events.</p>
        </div>
      )}
    </Container>
  );
};

export default Events;